import styled from "styled-components";

export const StyledContactsResultsTableWrapper = styled.div`
    z-index: 1;
    position: relative;

    & .ant-table-header.ant-table-sticky-holder {
        position: sticky;
        top: 215px !important;
        z-index: 99;
    }
`;
